'use es6';

import getIn from 'transmute/getIn';
import { FILE_ID, FILE_METADATA, FILE_USAGE_TYPE, THUMBNAIL_METADATA } from '../constants/resolvedAttachmentKeyPaths';
export const getFileId = getIn(FILE_ID);
export const getFileMetadata = getIn(FILE_METADATA);
export const getFileUsageType = getIn(FILE_USAGE_TYPE);
export const getThumbnailMetadata = getIn(THUMBNAIL_METADATA);